import { SortListType, Table } from "../../../table/table";
import { TableElement } from "../../../table/table-element";
import './company-affiliation-table.scss';

type Props = {
  tableBody: TableElement[][];
  sortList: SortListType[];
  setSortBy: React.Dispatch<React.SetStateAction<number>>;
  setHighlow: React.Dispatch<React.SetStateAction<number>>;
  setIndex: React.Dispatch<React.SetStateAction<number>>;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  isSelectCompanyUser: boolean;
};

const head: string[] = [
  '企業ID',
  '企業名(カナ)',
  '名前',
  '権限',
  'ステータス',
  '登録日',
  '',
];

export const CompanyAffiliationTable = (props: Props) => {
  const {
    tableBody,
    sortList,
    setSortBy,
    setHighlow,
    setIndex,
    setActive,
    isSelectCompanyUser,
  } = props;

  if(!isSelectCompanyUser) {
    return(<></>);
  }

  return(
    <div className="table_box_search">
      <Table
        head={head}
        body={tableBody}
        alignList={['c', 'l', 'c', 'c', 'c', 'c', 'c']}
        sortList={sortList}
        setSortBy={setSortBy}
        setHighlow={setHighlow}
        setActive={setActive}
        setIndex={setIndex}
        layoutStyle="table_sticky"
        minRowsCount={{ rowDataCount: 7, length: 3 }}
      />
    </div>
  );
};